// extracted by mini-css-extract-plugin
module.exports = {"Button":"styles_Button__jlIrj"};